import "./Tooltip_module.css";
const Tooltip_module = {
    tooltip: "tooltip__359ef39ab8ed4d33",
    tooltipContent: "tooltipContent__359ef39ab8ed4d33"
};
export { Tooltip_module as default };
